<template>
  <div class="mb-6">
    <strong
      v-show="enabledSublayer"
      class="secondary--text text--lighten-1 layer-title"
      >{{ group.name }}</strong
    >
    <v-radio-group class="ml-7" v-show="enabledSublayer" v-model="radioGroup">
      <div v-for="(location, index) in locations" :key="index">
        <radio-button-sublayer
          :location="location"
          :satellites="satellites"
          :value="index"
          :enableView="radioGroup === index"
          :initialOpacity="initialOpacity"
          :timeFeatures="listTimeFeatures"
          @changeOpacitySublayer="changeOpacitySublayer($event)"
          @changeTimeFeature="changeTimeFeature($event)"
          @changeSatelliteType="changeSatelliteType($event)"
          @currentState="emitCurrentState($event)"
        >
        </radio-button-sublayer>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
import RadioButtonSublayer from "./RadioButtonSublayer.vue";
export default {
  name: "RightSatelliteSublayer",
  props: ["group", "initialOpacity", "timeFeatures", "locations", "satellites"],
  components: {
    RadioButtonSublayer,
  },
  data: () => ({
    enabledSublayer: false,
    radioGroup: undefined,
    currentState: undefined,
  }),
  created() {
    if (this.enabledSublayer) {
      this.initialize();
    }
  },
  watch: {
    enabledSublayer(value) {
      if (value) {
        this.initialize();
      }
    },
  },
  computed: {
    listTimeFeatures() {
      return this.timeFeatures?.map((timeFeature) => ({
        title: timeFeature.title,
        value: timeFeature.value, //moment(timeFeature.value).format('YYYY-MM-DD')
      }));
    },
  },
  methods: {
    initialize() {
      this.radioGroup = 0;
      if (this.locations && this.satellites) {
        this.emitCurrentState({
          location: this.locations[0],
          satellite: this.satellites[0],
        });
      }
    },
    changeEnabledGrouplayer(visible) {
      this.$emit("changeInputMenu", {
        eventName: "changeEnabledGroupLayer",
        params: { visible, name: this.group.name },
      });
    },
    changeOpacitySublayer(opacity) {
      if (this.currentState) {
        this.currentState.opacity = opacity;
        this.emitCurrentState();
      }
    },
    changeTimeFeature(timeFeature) {
      if (this.currentState) {
        this.currentState.timeFeature = timeFeature;
        this.emitCurrentState();
      }
    },
    changeSatelliteType(satellite) {
      if (this.currentState) {
        this.currentState.satellite = satellite;
        this.emitCurrentState();
      }
    },
    emitCurrentState(state) {
      if (state) {
        this.currentState = { ...state };
        this.currentState.satellite = state.satellite.name
          ? state.satellite.name
          : state.satellite;
      }
      this.$emit("changeCurrentSatelliteState", { ...this.currentState });
    },
  },
};
</script>

<style></style>
